import Http from "../../http";

class NotificationServices {
  static async sendNotification(data) {
    return Http.post('/notification/send', data);
  }

  static async sendUserNotification(data) {
    console.log('i am sendning notification services===========', data)
    return Http.post('/user/notification/send', data);
  }

  static async notificationStoreAndSend(data) {

    // console.log('Final Payload Sent to API:', JSON.stringify(data, null, 2));
    return Http.post('/notification/StoreAndSend', data);

  }

}

export default NotificationServices;
